import { render, staticRenderFns } from "./CGVPopup.vue?vue&type=template&id=7666fb72&"
import script from "./CGVPopup.vue?vue&type=script&lang=js&"
export * from "./CGVPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports